import React, { useState } from "react";
import ProductForm from "./redundant/ProductForm";
import "../App.css";
import { useLanguage } from "../i18n/LanguageContext";

function AdminDashboard() {
  const { t } = useLanguage();
  const [editingProduct, setEditingProduct] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");

  const handleSuccess = () => {
    setSuccessMessage(t("adminDashboard.saved"));
    setTimeout(() => setSuccessMessage(""), 4000);
    setEditingProduct(null);
  };

  return (
    <div className="dashboard">
      <h2>{t("adminDashboard.title")}</h2>
      {successMessage && <div className="success-banner">{successMessage}</div>}
      <ProductForm
        onSuccess={handleSuccess}
        editingProduct={editingProduct}
        setEditingProduct={setEditingProduct}
      />
    </div>
  );
}

export default AdminDashboard;
